// Add all test keys here and import to wherever the treatments are needed
const SPLIT_TREATMENTS = {
  // NOTE: Uncomment the split-io stuff in the App.jsx file to use split.io
  USER_FEEDBACK_SEARCH_PAGE: 'PD-1513_User-feedback-form-search-page',
  USER_FEEDBACK_APPOINTMENT_DETAILS: 'PD-1513_User-feedback-form-appointment-details',
  GIFT_VOUCHERS_CONFIG: 'UD-639_Gift-vouchers-config',
  GIFT_MAX_CHARS: 'UD-615_Gifts-max-characters',
  REQUEST_TO_BOOK: 'UD-384_Request-to-book',
};

export default SPLIT_TREATMENTS;



// WEBPACK FOOTER //
// ./spa/state/SplitTreatmentIdMap.jsx